(function () {
  'use strict';

  var CONTENT_SEL = 'main.main-content';
  var SKIP_PATHS  = ['/cart', '/checkout', '/account', '/password'];

  /* ─── helpers ─────────────────────────────────────────────── */

  function shouldSkip(href) {
    try {
      var u = new URL(href, location.href);
      if (u.origin !== location.origin) return true;
      if (u.hash && u.pathname === location.pathname) return true;
      return SKIP_PATHS.some(function (p) { return u.pathname.indexOf(p) === 0; });
    } catch (e) { return true; }
  }

  function execScripts(container) {
    var scripts = container.querySelectorAll('script');
    [].forEach.call(scripts, function (orig) {
      var s = document.createElement('script');
      if (orig.src) return; // external – skip re-load (already in page)
      s.textContent = orig.textContent;
      document.head.appendChild(s);
      document.head.removeChild(s);
    });
  }

  function reInitLazy(container) {
    if (!window.lazySizes) return;
    var imgs = container.querySelectorAll('.lazyload');
    [].forEach.call(imgs, function (img) {
      img.classList.remove('lazyloaded', 'lazyprocessed');
    });
    lazySizes.init();
  }

  function updateNavActive() {
    var path = location.pathname;

    // clear previous active state
    [].forEach.call(document.querySelectorAll('[aria-current="page"]'), function (el) {
      el.removeAttribute('aria-current');
    });
    [].forEach.call(document.querySelectorAll('.site-nav--active, .mobile-nav--active'), function (el) {
      el.classList.remove('site-nav--active', 'mobile-nav--active');
    });

    // for each nav type find best (longest) matching link
    [
      { links: document.querySelectorAll('#AccessibleNav .site-nav--link'), cls: 'site-nav--active' },
      { links: document.querySelectorAll('#MobileNav .mobile-nav--link'),   cls: 'mobile-nav--active' }
    ].forEach(function (nav) {
      var best = null, bestLen = 0;
      [].forEach.call(nav.links, function (a) {
        try {
          var lp = new URL(a.href, location.href).pathname;
          if (path === lp || path.indexOf(lp + '/') === 0) {
            if (lp.length > bestLen) { bestLen = lp.length; best = a; }
          }
        } catch (e) {}
      });
      if (!best) return;
      best.setAttribute('aria-current', 'page');
      // mark the immediate <li> and its parent <li> (if nested)
      var li = best.closest('li');
      while (li) {
        li.classList.add(nav.cls);
        var up = li.parentElement && li.parentElement.closest('li');
        li = (up && up !== li) ? up : null;
      }
    });
  }

  function closeMobileNav() {
    var html = document.documentElement;
    if (!html.classList.contains('show-nav')) return;
    html.classList.remove('show-nav');
    var toggle = document.querySelector('.menu-toggle');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    var siteHeader = document.querySelector('.site-header');
    if (siteHeader) siteHeader.classList.remove('site-header--hidden');
    try {
      if (window.theme && theme.a11y && typeof theme.a11y.removeTrapFocus === 'function') {
        theme.a11y.removeTrapFocus({ $container: jQuery('#shopify-section-header'), namespace: 'mobileMenuToggle' });
      }
    } catch (e) {}
  }

  function reInitTheme() {
    closeMobileNav();
    updateNavActive();

    try {
      if (window.timber && typeof timber.init === 'function') timber.init();
    } catch (e) {}

    try {
      if (window.ajaxifyShopify && typeof ajaxifyShopify.refresh === 'function') {
        ajaxifyShopify.refresh();
      }
    } catch (e) {}

    if (typeof window.tmSyncGridButtons === 'function') {
      window.tmSyncGridButtons();
    }

    try {
      var $selects = jQuery('.product-variants select');
      $selects.each(function () {
        jQuery(this).trigger('change');
      });
    } catch (e) {}
  }

  /* ─── core swap ───────────────────────────────────────────── */

  var inProgress = false;
  var inProgressTimer = null;

  function resetProgress() {
    inProgress = false;
    if (inProgressTimer) { clearTimeout(inProgressTimer); inProgressTimer = null; }
    var m = document.querySelector(CONTENT_SEL);
    if (m) m.style.opacity = '';
  }

  function navigate(url, push) {
    if (inProgress) return;
    inProgress = true;

    // safety: always release lock after 10s max
    inProgressTimer = setTimeout(resetProgress, 10000);

    var oldMain = document.querySelector(CONTENT_SEL);
    if (oldMain) oldMain.style.opacity = '0.5';

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newMain = doc.querySelector(CONTENT_SEL);
        oldMain = document.querySelector(CONTENT_SEL);

        if (!newMain || !oldMain) {
          location.href = url;
          return;
        }

        oldMain.innerHTML = newMain.innerHTML;
        oldMain.style.opacity = '';

        document.title = doc.title;

        var newBodyClass = doc.body.className;
        if (newBodyClass) document.body.className = newBodyClass;

        if (push) history.pushState({ url: url }, doc.title, url);

        window.scrollTo(0, 0);

        execScripts(oldMain);
        reInitLazy(oldMain);
        reInitTheme();
      })
      .catch(function () {
        location.href = url;
      })
      .then(function () {
        resetProgress();
      });
  }

  /* ─── intercept search form submissions ──────────────────── */

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if ((form.getAttribute('method') || 'get').toLowerCase() !== 'get') return;

    var action = form.getAttribute('action') || location.href;
    if (shouldSkip(action)) return;

    var params = [];
    var els = form.elements;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (!el.name || el.disabled) continue;
      if (el.type === 'radio' || el.type === 'checkbox') { if (!el.checked) continue; }
      if (el.type === 'submit' || el.type === 'button' || el.type === 'image') continue;
      params.push(encodeURIComponent(el.name) + '=' + encodeURIComponent(el.value));
    }

    var url = action + (params.length ? '?' + params.join('&') : '');
    e.preventDefault();
    navigate(url, true);
  }, { capture: true });

  /* ─── intercept clicks ────────────────────────────────────── */

  // capture:true — runs before any bubble-phase or stopPropagation in theme JS
  document.addEventListener('click', function (e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var a = e.target.closest('a[href]');
    if (!a) return;
    if (a.target === '_blank') return;
    if (a.getAttribute('data-no-pjax') != null) return;

    var href = a.href;
    try {
      var u = new URL(href, location.href);
      if (u.origin === location.origin && u.pathname === '/' && window.tmHomeUrl) {
        href = window.tmHomeUrl;
      }
    } catch (e) {}

    if (shouldSkip(href)) return;

    e.preventDefault();
    navigate(href, true);
  }, { capture: true });

  /* ─── browser back / forward ──────────────────────────────── */

  window.addEventListener('popstate', function () {
    navigate(location.href, false);
  });

  // save initial state
  history.replaceState({ url: location.href }, document.title, location.href);

  window.tmNavigate = navigate;

})();
